import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-branding-profile-setup',
  templateUrl: './customer-branding-profile-setup.component.html',
  styleUrls: ['./customer-branding-profile-setup.component.css']
})
export class CustomerBrandingProfileSetupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
